"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    index: "/01",
    title: "HYDROIZOLACJA DACHÓW PŁASKICH",
    description: "Profesjonalne uszczelnianie dachów płaskich przy użyciu bezspoinowych membran natryskowych. Nasza technologia tworzy jednolitą, elastyczną powłokę, która skutecznie eliminuje przecieki i chroni konstrukcję przed degradacją przez wiele lat.",
    features: ["Bezspoinowa technologia natryskowa", "Pełna odporność na promieniowanie UV", "Doskonała przyczepność do papy i betonu", "Szybka aplikacja bez zrywania starego pokrycia"],
    image: {
      src: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/hala_przemyslowa_malopolska.png?v=jc7je9us0o",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/spray_insulation_on_roof.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/spray_insulation_on_roof.png-wvc-sizes",
      alt: "Placeholder image for service"
    },
    imageLeft: true
  }, {
    index: "/02",
    title: "MALOWANIE DACHU HALI PRZEMYSŁOWEJ NATRYSKIEM, NAKŁADANIE MEMBRANY",
    description: "Profesjonalne malowanie dachu hali przemysłowej metodą natryskową z jednoczesnym nakładaniem wysokiej jakości membrany ochronnej, zapewniającej trwałą ochronę i estetyczny wygląd.",
    features: ["Ochrona antykorozyjna konstrukcji", "Wysoka odporność na obciążenia mechaniczne", "Minimalizacja przestojów w produkcji", "Długoletnia gwarancja szczelności"],
    image: {
      src: "https://hydroroofs.pl/wp-content/uploads/2026/07/08384AB3-A744-4548-AF8A-41E3676C5915.png?v=ipgvgrpxsa",
      srcset: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/hydro_roof_spray_application.png?v=4yme6zof76-wvc-srcset",
      sizes: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/hydro_roof_spray_application.png?v=29e5pgfr8pv-wvc-sizes",
      alt: "Painting industrial hall roof with spray-applied membrane"
    },
    imageLeft: false
  }, {
    index: "/03",
    title: "HYDROIZOLACJA TARASÓW I BALKONÓW",
    description: "Skuteczne uszczelnianie tarasów i balkonów, które zapobiega przenikaniu wilgoci do wnętrza budynku. Nasze powłoki są estetyczne, antypoślizgowe i niezwykle trwałe w każdych warunkach pogodowych.",
    features: ["Systemy wodoszczelne odporne na mróz", "Estetyczne wykończenie powierzchni", "Ochrona przed pękaniem płytek", "Szybki czas utwardzania powłoki"],
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hydroizolacja_taras.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hydroizolacja_taras.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1726265/img/hydroizolacja_taras.png-wvc-sizes",
      alt: "Hydroizolacja tarasu z wykorzystaniem płynnej membrany"
    },
    imageLeft: true
  }, {
    index: "/04",
    title: "MALOWANIE I KONSERWACJA DACHÓW",
    description: "Profesjonalne malowanie dachów skośnych i płaskich, które przywraca im estetyczny wygląd oraz dodatkowo zabezpiecza przed czynnikami zewnętrznymi. Stosujemy specjalistyczne farby o wysokiej trwałości.",
    features: ["Przygotowanie podłoża i czyszczenie", "Farby o wysokiej odporności na UV", "Zabezpieczenie przed porastaniem mchem", "Wydłużenie żywotności pokrycia dachowego"],
    image: {
      src: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5853-scaled.jpeg?v=a2ylyfj5gom",
      srcset: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5853-scaled.jpeg?v=k5w8bowc8oj-wvc-srcset",
      sizes: "https://hydroroofs.pl/wp-content/uploads/2026/09/IMG_5853-scaled.jpeg?v=8tl9shspu2o-wvc-sizes",
      alt: "Malowanie dachu skośnego specjalistyczną farbą ochronną"
    },
    imageLeft: false
  }, {
    index: "/05",
    title: "NAPRAWA PRZECIEKÓW NA DACHU PŁASKIM Z NATRYSKU POLIURETANU",
    description: "Detailed description of the polyurethane liquid membrane sealing method.",
    features: ["bezspoinowa membrana", "elastyczność", "szybkie utwardzanie", "długotrwała ochrona"],
    image: {
      src: "https://curious-moray.10web.cloud/wp-content/uploads/2026/07/08384AB3-A744-4548-AF8A-41E3676C5915.png?v=ma6jk6z9l29",
      srcset: "",
      sizes: "",
      alt: "Naprawa przecieków zalewaniem płynną membrana poliuretanową"
    },
    imageLeft: true
  }];
  return <section data-section-id="5317" id="spektrum-działań" className="bg-background text-foreground pt-32 pb-24 md:pt-44 md:pb-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        <div ref={header.ref} className={`transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-10">
            <span className="text-primary text-lg" style={{
            lineHeight: 1
          }}>
              ●
            </span>
            <span className="font-sans text-xs uppercase tracking-[0.2em] text-muted-foreground" style={{
            fontWeight: 500
          }}>
              USŁUGI / HYDROIZOLACJA
            </span>
          </div>

          <h1 className="font-sans font-default font-extrabold uppercase leading-[0.9] tracking-tight" style={{
          fontSize: "clamp(64px, 11vw, 180px)"
        }}>
            <span className="block !text-9xl">PROFESJONALNA</span>
            <span className="block md:pl-[100px]">
              <span className="font-sans italic font-normal !text-9xl">HYDROIZOLACJA</span>
            </span>
          </h1>

          <div className="mt-12 md:mt-16 md:pl-[100px] max-w-[580px]">
            <p className="font-sans italic text-foreground/85 leading-snug" style={{
            fontSize: "clamp(18px, 1.6vw, 24px)"
          }}>
              HydroRoof to ekspert w dziedzinie bezspoinowych powłok natryskowych. 
              Zapewniamy trwałą ochronę dachów, tarasów i obiektów przemysłowych, 
              łącząc nowoczesną technologię z precyzją wykonania.
            </p>
          </div>
        </div>

        <div className="mt-20 md:mt-28 space-y-16 md:space-y-20">
          {services.map((service, i) => {
          const reveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div data-index={i} key={i} ref={reveal.ref} className={`transition-all duration-1000 ease-out ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <article className="grid grid-cols-1 lg:grid-cols-12 bg-card backdrop-blur-xl border border-border/60 shadow-lg min-h-[600px]" style={{
              backgroundColor: "hsla(0, 0%, 100%, 0.03)"
            }}>
                  <div className={`lg:col-span-5 relative overflow-hidden aspect-[4/3] lg:aspect-auto ${service.imageLeft ? "lg:order-1" : "lg:order-2"}`}>
                    <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover grayscale contrast-110" />
                    <div className="absolute inset-0 bg-primary/20 mix-blend-multiply" />
                  </div>

                  <div className={`lg:col-span-6 lg:col-start-${service.imageLeft ? "7" : "1"} relative p-8 md:p-12 lg:p-16 flex flex-col justify-center ${service.imageLeft ? "lg:order-2" : "lg:order-1"}`}>
                    

                    <h2 className="font-sans font-default font-bold uppercase tracking-tight leading-[1.05] text-foreground" style={{
                  fontSize: "clamp(28px, 3.5vw, 48px)"
                }}>
                      {service.title}
                    </h2>

                    <div className="mt-8 mb-8 h-px w-20 bg-primary" />

                    <p className="font-sans text-foreground/80 leading-relaxed max-w-[520px]" style={{
                  fontSize: "18px"
                }}>
                      {service.description}
                    </p>

                    <ul className="mt-10 space-y-3">
                      {service.features.map((feature, fi) => <li data-index={fi} key={fi} className="flex items-start gap-3">
                          <span className="inline-block w-1.5 h-1.5 bg-primary mt-[7px] shrink-0" aria-hidden="true" />
                          <span className="font-sans text-foreground/75 uppercase" style={{
                      fontSize: "14px",
                      letterSpacing: "0.16em",
                      fontWeight: 500
                    }}>
                            {feature}
                          </span>
                        </li>)}
                    </ul>

                    <div className="mt-12">
                      <Button asChild variant="link" className="h-auto p-0 text-foreground hover:text-primary transition-colors">
                        <Link to="/ContactPage" className="group inline-flex items-center gap-3 font-sans uppercase" style={{
                      fontSize: "13px",
                      letterSpacing: "0.2em",
                      fontWeight: 600,
                      textDecorationColor: "var(--primary)",
                      textUnderlineOffset: "8px",
                      textDecorationThickness: "1px"
                    }}>
                          <span className="underline decoration-primary underline-offset-8">
                            ZAPYTAJ O WYCENĘ
                          </span>
                          <ArrowRight className="w-4 h-4 text-primary transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </article>
              </div>;
        })}
        </div>
      </div>
    </section>;
}